<template>
  <div>
    <div class="title_h1">トップ</div>
    <div class="dlIndex">
      <el-collapse v-model="activeName">
        <el-collapse-item
          v-for="(item, index) in list"
          :key="index"
          :name="item.name"
        >
          <template slot="title">
            <div class="h_title">{{ item.name }}</div>
          </template>
          <div v-if="item.name == '予定'" class="cal_margin">
            <vab-calendar ref="calendar">
              <div slot="noday"></div>
            </vab-calendar>
          </div>
          <div v-else>
            <div class="flex_colum">
              <div
                v-for="(s1, s1index) in item.children"
                :key="s1index"
                class="moude_item margin_width_0"
              >
                <div class="mark_box">
                  {{ s1.name }}
                </div>
                <div class="line_2px"></div>
                <div class="flex_colum">
                  <div
                    v-for="(s2, s2index) in s1.children"
                    :key="s2index"
                    :class="s1.children.length - s2index > 1 ? 'mr20' : ''"
                    class="nums_box flex_wrap"
                  >
                    <div class="header_box flex_start padding_4">
                      <span class="title">{{ s2.name }}</span>
                      <span class="link" @click="openPageLink(s1.name, s2)">
                        すべて見る
                        <i class="el-icon-arrow-right el-icon--right"></i>
                      </span>
                    </div>
                    <div class="flex_start max_width">
                      <div
                        v-for="(s3, s3index) in s2.children"
                        :key="s3index"
                        class="nums_item flex_space flex_center_align"
                        :class="
                          s3.num == 0
                            ? 'nums_item-grey new_nums_item-grey '
                            : 'nums_item-blue'
                        "
                        @click="
                          ;['作業予定', '作業実績', '作業報告書'].includes(
                            s1.name
                          )
                            ? openYm(s1.name, s3)
                            : openPage(s1.name, s3)
                        "
                      >
                        <span class="word">{{ s3.name }}</span>
                        <span class="num">
                          {{ s3.num > 99 ? '99+' : s3.num }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-dialog
        :close-on-press-escape="false"
        custom-class="layout-dialog"
        title="検索対象となる作業年月を設定"
        top="5vh"
        width="580px"
        :visible="dialogVisible"
        append-to-body
        @close="close"
      >
        <vab-form
          ref="form"
          :model="queryForm"
          :rules="rules"
          size="mini"
          label-width="90px"
        >
          <vab-row :gutter="20">
            <vab-col :lg="23" :xl="23" :md="23" :sm="23">
              <el-form-item
                class="big_label_110 is-required"
                label="作業年月"
                prop="workYm"
              >
                <el-select
                  v-model="queryForm.workYm"
                  placeholder="選択されていません"
                  @change="getVal"
                >
                  <el-option
                    v-for="(item, index) in workYmList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </vab-col>
          </vab-row>
        </vab-form>
        <div slot="footer" class="dialog-footer flex_end">
          <div class="flex_start flex_center_align">
            <div class="flex_end">
              <vab-button :btn-list="btnList" />
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import { getTopWorkableDateTimeList } from '@/api/workableDateRequest'
  import {
    workpush,
    scStats,
    monthly,
    flashReport,
    officialReport,
    workingPlanAndResults,
    resultDateInputStatus,
  } from '@/api/worksTop'
  export default {
    name: 'TOP',
    data() {
      return {
        activeName: 'タスク一覧',
        list: [
          {
            name: 'タスク一覧',
            children: [
              {
                name: '日程調整',
                num: 10,
                children: [
                  {
                    name: '日程調整状況（事前調査）',
                    key: 'investigationAdjScheduleList',
                    prop: 'investigationAdjSchedule',
                    emum: 'adjScheduleStatusEnum',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        num: 0,
                        status: '01',
                      },
                      {
                        name: '提出済み',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '差し戻し',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '再調整',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                    ],
                  },
                  {
                    name: '日程調整状況（工事）',
                    key: 'constructionAdjScheduleList',
                    emum: 'adjScheduleStatusEnum',
                    prop: 'constructionAdjSchedule',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        num: 0,
                        status: '01',
                      },
                      {
                        name: '提出済み',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '差し戻し',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '再調整',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                    ],
                  },
                ],
              },
              {
                name: '作業可能日',
                num: 55,
                children: [
                  {
                    name: '回答状況',
                    key: 'requestStatusList',
                    emum: 'requestStatusEnum',
                    prop: 'requestStatus',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        num: 0,
                        status: '01',
                      },
                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                    ],
                  },
                ],
              },
              {
                name: '見積書等確認',
                num: 8,
                children: [
                  {
                    name: '書類提出状況',
                    key: 'costEstimateList',
                    prop: 'costEstimate',
                    emum: 'docSubmitStatusEnum',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        num: 0,
                        status: '01',
                      },
                      {
                        name: '提出済み',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '差し戻し',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                    ],
                  },
                ],
              },
              {
                name: '報告書確認',
                num: 24,
                children: [
                  {
                    name: '報告書提出状況',
                    key: 'docSubmitStatsList',
                    prop: 'docSubmitStats',
                    emum: 'docSubmitStatusEnum',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        num: 0,
                        status: '01',
                      },
                      {
                        name: '提出済み',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                      {
                        name: '差し戻し',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },
                    ],
                  },
                ],
              },
              {
                name: '作業予定',
                children: [
                  {
                    name: 'ステータス',
                    key: 'workingPlanAndResultList',
                    prop: 'workingPlanAndResult',
                    emum: 'wparStatusEnum',
                    children: [
                      {
                        name: '発注予定',
                        aniTemp: false,
                        num: 0,
                        status: '01',
                      },
                      {
                        name: '入力待ち ',
                        aniTemp: false,
                        num: 0,
                        status: '02',
                      },

                      {
                        name: '催促要',
                        aniTemp: false,
                        num: 0,
                        status: '04',
                      },
                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '04',
                      },
                      {
                        name: '入力済み',
                        aniTemp: false,
                        num: 0,
                        status: '06',
                      },
                      {
                        name: '日程要変更',
                        aniTemp: false,
                        num: 0,
                        status: '07',
                      },
                      {
                        name: '確認待ち',
                        aniTemp: false,
                        num: 0,
                        status: '09',
                      },
                      {
                        name: '連絡中',
                        aniTemp: false,
                        num: 0,
                        status: '09',
                      },
                    ],
                  },
                ],
              },
              {
                name: '作業実績',
                children: [
                  {
                    name: '作業実績入力状況',
                    key: 'resultDateInputStatusList',
                    emum: 'resultDateInputStatusEnum',
                    prop: 'resultDateInputStatus',
                    children: [
                      {
                        name: '未入力',
                        aniTemp: false,
                        num: 0,
                        status: '0',
                      },

                      {
                        name: '催促中',
                        aniTemp: false,
                        num: 0,
                        status: '1',
                      },
                    ],
                  },
                ],
              },
              {
                name: '作業報告書',
                children: [
                  {
                    name: '速報版報告書状況',
                    key: 'flashReportList',
                    emum: 'reportStatusEnum',
                    prop: 'flashReport',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        key: 'preReportStatusPartnerEnum00',
                        num: 0,
                      },
                      {
                        name: '協力会社へ催促中',
                        aniTemp: false,
                        key: 'preReportStatusPartnerEnum01',
                        num: 0,
                      },
                      {
                        name: '管理部確認済み',
                        aniTemp: false,
                        key: 'preReportStatusPartnerEnum04',
                        num: 0,
                      },
                    ],
                  },
                  {
                    name: '正式版報告書状況',
                    key: 'officialReportList',
                    emum: 'reportStatusEnum',
                    prop: 'officialReport',
                    children: [
                      {
                        name: '未提出',
                        aniTemp: false,
                        key: 'officalReportStatusPartnerEnum00',
                        num: 0,
                      },
                      {
                        name: '協力会社へ催促中',
                        aniTemp: false,
                        key: 'officalReportStatusPartnerEnum01',
                        num: 0,
                      },
                      {
                        name: '管理部差し戻し',
                        aniTemp: false,
                        key: 'officalReportStatusPartnerEnum04',
                        num: 0,
                      },
                      {
                        name: '管理部確認済み',
                        aniTemp: false,
                        key: 'officalReportStatusPartnerEnum11',
                        num: 0,
                      },
                      {
                        name: 'LC確認済(組合確認済)',
                        aniTemp: false,
                        key: 'officalReportStatusPartnerEnum11',
                        num: 0,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            name: '予定',
            children: [],
          },
        ],
        timeList: [],
        dialogVisible: false,
        queryForm: {
          division: null,
        },
        rules: {},
        workYmList: [],
        btnList: [
          {
            name: 'キャンセル',
            type: 'button',
            hidden: false,
            click: () => {
              this.close()
            },
          },
          {
            name: '選択',
            icon: 'answer',
            type: 'button',
            hidden: false,
            disabled: true,
            click: () => {
              this.submitForm()
            },
          },
        ],
        name: null,
      }
    },
    watch: {
      activeName(val) {
        if (val.includes('予定') && this.timeList.length == 0) {
          this.getCalendarList()
        }
      },
      'queryForm.workYm': {
        handler(val) {
          if (val) {
            this.btnList[1].disabled = false
          } else {
            this.btnList[1].disabled = true
          }
        },
      },
      deep: true,
      immediate: true,
    },
    async created() {
      scStats().then((res) => {
        this.setDataList(this.list, res)
      })

      flashReport().then((res) => {
        let data = {
          flashReportList: res,
        }
        this.setDataList(this.list, data)
      })

      officialReport().then((res) => {
        let data = {
          officialReportList: res,
        }
        this.setDataList(this.list, data)
      })

      workingPlanAndResults().then((res) => {
        let data = {
          workingPlanAndResultList: res,
        }
        this.setDataList(this.list, data)
      })

      resultDateInputStatus().then((res) => {
        let data = {
          resultDateInputStatusList: res,
        }
        this.setDataList(this.list, data)
      })
      // let list = [
      //   flashReport(),
      //   officialReport(),
      //   workingPlanAndResults(),
      //   resultDateInputStatus(),
      // ]
      // let res = await Promise.all(list)
      // // let rcdata = {
      // //   flashReportList: res[0],
      // //   officialReportList: res[1],
      // //   workingPlanAndResultList: res[2],
      // //   resultDateInputStatusList: res[3],
      // // }
      // let data0 = {
      //   flashReportList: res[0],
      // }
      // let data1 = {
      //   officialReportList: res[1],
      // }
      // let data2 = {
      //   workingPlanAndResultList: res[2],
      // }
      // let data3 = {
      //   resultDateInputStatusList: res[3],
      // }
      // this.setDataList(this.list, data0)
      // this.setDataList(this.list, data1)
      // this.setDataList(this.list, data2)
      // this.setDataList(this.list, data3)
    },
    mounted() {
      // this.getList()
      const pushId = this.$route.query.pushId
      this.workPush(pushId)
    },
    methods: {
      openPageLink(type, row) {
        let query = {
          top: 'top',
        }
        switch (type) {
          case '日程調整':
            if (row) {
              if (row.key == 'investigationAdjScheduleList') {
                query.requestClassList = [
                  this.$divisions.requestClassEnum.enum_1.value,
                ]
              } else {
                query.requestClassList = [
                  this.$divisions.requestClassEnum.enum_2.value,
                ]
              }
            }
            this.$routerPush({
              name: 'PWS02G01',
              query: query,
            })
            break
          case '作業可能日':
            this.$routerPush({
              name: 'PWS02G05',
              query: query,
            })
            break
          case '見積書等確認':
            this.$routerPush({
              name: 'PWS02G01',
              query: query,
            })
            break
          case '報告書確認':
            this.$routerPush({
              name: 'PWS03G01',
              query: query,
            })
            break
          case '作業予定':
            this.$routerPush({
              name: 'PWR01G01',
              query: query,
            })
            break
          case '作業実績':
            this.$routerPush({
              name: 'PWR02G04',
              query: query,
            })
            break
          case '作業報告書':
            this.$routerPush({
              name: 'PWR02G05',
              query: query,
            })
            break
        }
      },
      setDataList(list, data) {
        list?.filter((item) => {
          if (item.key) {
            Object.keys(data).filter((key) => {
              if (key == item.key && data[key]) {
                data[key].filter((row) => {
                  row.name = this.getEnumText(
                    row.division,
                    this.$divisions[item.emum]
                  )
                  row.aniTemp = false
                  if (item.key == 'investigationAdjScheduleList') {
                    row.requestClassValue =
                      this.$divisions.requestClassEnum.enum_1.value
                  } else if (item.key == 'constructionAdjScheduleList') {
                    row.requestClassValue =
                      this.$divisions.requestClassEnum.enum_2.value
                  }
                  if (item.key == 'officialReportList') {
                    row.key = 'officalReportStatusList'
                  } else if (item.key == 'flashReportList') {
                    row.key = 'preReportStatusList'
                  } else if (item.key == 'finishFlgList') {
                    row.key = 'workFinishClassList'
                  }
                  row.num = row.totalCount
                  row.prop = item.prop
                })
                item.children = data[key]
              }
            })
          } else {
            if (item.children) {
              this.setDataList(item.children, data)
            }
          }
        })
      },
      // 既読の催促履歴が
      async workPush(pushId) {
        if (Number(pushId) > 0) {
          await workpush(pushId)
        }
      },
      //カレンダーデータを取得する
      async getCalendarList(info) {
        let data = {
          requestYearMonth:
            info?.requestYearMonth ??
            this.$dayjs().format(this.$const.dateFormatYYYYMMDD),
          partnerTopFlag: true,
        }

        const loadingInstance = this.$baseColorfullLoading()
        try {
          let res = await getTopWorkableDateTimeList(data)
          if (res?.length && res.length > 0) {
            this.$nextTick(() => {
              this.$refs.calendar[0]
                .getTimes(data.requestYearMonth)
                .then(() => {
                  this.$refs.calendar[0].setPageData(data)
                  this.$refs.calendar[0].setCalenderTime(res, this)
                })
            })
          }
        } finally {
          loadingInstance.close()
        }
      },
      openPage(type, row) {
        if (row?.num < 1) return
        let query = {
          top: 'top',
        }
        if (row?.workYm) {
          query.workYm = row?.workYm
          query.workYmTo = row?.workYm
        }
        switch (type) {
          case '日程調整':
            if (row) {
              query = {
                adjScheduleStatusList: [row.division],
                requestClassList: [row.requestClassValue],
                top: 'top',
              }
            }
            this.$routerPush({
              name: 'PWS02G01',
              query: query,
            })
            break
          case '作業可能日':
            if (row) {
              // query = {
              //   requestStatusList: [row.division],
              //   top: 'top',
              // }
              row.work = true
              this.openYm(type, row)
            } else {
              this.$routerPush({
                name: 'PWS02G05',
                query: query,
              })
            }
            break
          case '見積書等確認':
            if (row) {
              query = {
                docSubmitStatusList: [row.division],
                top: 'top',
              }
            }
            this.$routerPush({
              name: 'PWS02G01',
              query: query,
            })
            break
          case '報告書確認':
            if (row) {
              query = {
                reportSubmitStatusList: [row.division],
                top: 'top',
              }
            }
            this.$routerPush({
              name: 'PWS03G01',
              query: query,
            })
            break
          case '作業予定':
            if (this?.division) {
              query.changeStatusList = [this?.division]
              query.switch = '01'
            }
            this.$routerPush({
              name: 'PWR01G01',
              query: query,
            })
            break
          case '作業実績':
            if (this?.division) {
              query.resultDateInputStatusList = [this?.division]
            }
            this.$routerPush({
              name: 'PWR02G04',
              query: query,
            })
            break
          case '作業報告書':
            if (this?.division) {
              query[this.key] = [this?.division]
            }
            // 速報版報告書状況  preReportStatusList
            // 正式版報告書状況  officalReportStatusList
            this.$routerPush({
              name: 'PWR02G05',
              query: query,
            })
            break
        }
      },
      async openYm(name, data) {
        if (data.num === 0) return
        let list = []
        try {
          if (data.countListPerMonth == null) {
            this.$baseColorfullLoading()
            list =
              (await monthly({ type: data.prop, state: data?.division })) || []
          } else {
            list = data.countListPerMonth
          }
        } finally {
          this.$baseColorfullLoading().close()
        }
        if (list.length == 0) return
        // list.sort(function (a, b) {
        //   return b.workYm - a.workYm
        // })
        list.filter((item) => {
          if (item.workYm) {
            item.label = `${this.$dayjs(item.workYm + '').format(
              'YYYY/MM'
            )}（検索結果：${item.count}件）`
            item.value = item.workYm.toString()
          }
        })
        this.workYmList = list
        this.division = data?.division
        this.key = data?.key
        this.name = name
        this.work = data?.work
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      getVal(val) {
        this.$nextTick(() => {
          this.queryForm.division = this.workYmList.filter(
            (v) => v.value === val
          )[0].division
        })
        this.$forceUpdate()
      },
      close() {
        this.$refs.form.resetFields()
        this.$refs.form.clearValidate()
        this.dialogVisible = false
        this.name = null
      },
      submitForm() {
        if (this.work) {
          this.$routerPush({
            name: 'PWS02G05',
            query: {
              requestStatusList: [this.division],
              top: 'top',
              requestYearMonth: this.$dayjs(this.queryForm.workYm + '').format(
                this.$const.dateFormatYYYYMMDD
              ),
            },
          })
        } else {
          this.openPage(this.name, this.queryForm)
        }
        this.close()
      },
    },
  }
</script>

<style scoped lang="scss">
  // デフォルトの方向
  .dlIndex ::v-deep .el-collapse-item__arrow {
    transform: rotate(90deg);
  }
  // クリック後の方向
  .dlIndex ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }
  @mixin animate {
    animation-duration: 0.2s;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-fill-mode: forwards;
  }
  .dlIndex {
    .h_title {
      position: relative;
      height: 40px;
      padding-left: 12px;
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      &::before {
        position: absolute;
        top: 60%;
        left: 0;
        width: 4px;
        height: 16px;
        margin-top: -10px;
        content: '';
        background: #003350;
      }
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__header {
      background: none !important;
      border: none !important;
    }
  }

  .dlIndex ::v-deep {
    .el-collapse-item__header .el-collapse-item__arrow {
      font-size: 15px;
      font-weight: 300;
      color: inherit;
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__header:first-child {
      border-bottom: 1px solid #d1dae1 !important;
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__wrap {
      background: none;
    }
  }
  .dlIndex ::v-deep {
    .el-collapse-item__content {
      line-height: inherit;
    }
  }
  .mark_box {
    height: 24px;
    padding-bottom: 8px;
    color: #003350;
    font-weight: 700;
    font-size: 15px;
    border-bottom: 2px solid #003350;
    margin-bottom: 20px;
  }
  .dlIndex {
    .moude_item {
      padding: 24px 24px 16px;
      margin: 0 8px;
      margin-top: 12px;
      overflow: inherit;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
    }

    .nums_box {
      .header_box {
        margin-bottom: 8px;
        .title {
          display: block;
          font-size: 14px;
          font-weight: 400;
          color: #848484;
        }
        .link {
          margin-left: 16px;
          font-size: 13px;
          font-weight: 400;
          color: #004c82;
          text-decoration-line: underline;
          cursor: pointer;
        }
      }
      .nums_item-blue {
        background: #ecf5ff;
        .num {
          color: #004c82;
        }
      }
      .nums_item-grey {
        background: #efefef;
        .num {
          color: #bababa;
        }
        &:hover {
          background: #efefef !important;
          .word {
            color: #000000 !important;
          }
          .num {
            color: #bababa !important;
            &::before {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 0px !important;
              content: '';
              background: #fff;
            }
          }
        }
      }
      .nums_item {
        position: relative;
        width: 170px;
        height: 56px;
        padding: 0 16px;
        margin-right: 8px;
        overflow: hidden;
        cursor: pointer;
        border-radius: 4px;
        margin-bottom: 8px;
        &:hover {
          background: #71b4ff;
          .word {
            color: #fff;
          }
          .num {
            position: relative;
            color: #fff;
            &::before {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 1px;
              content: '';
              background: #fff;
            }
          }
        }

        .word {
          display: block;
          font-size: 13px;
          font-weight: 400;
          color: #000000;
        }
        .num {
          position: relative;
          z-index: 2;
          display: block;
          font-size: 24px;
          font-weight: 700;
          color: #004c82;
        }
        .round {
          position: absolute;
          top: 56px;
          right: -130px;
          z-index: 1;
          width: 130px;
          height: 130px;
          background: #ecf5ff;
          border-radius: 50%;
        }
      }

      .max_width {
        max-width: 1000px;
        flex-wrap: wrap;
      }
    }
  }
  @keyframes ani {
    0% {
      opacity: 0;
    }
    100% {
      background: #71b4ff;
      opacity: 1;
    }
  }
  .cal_margin {
    margin-top: 12px;
    background: #fff;
  }
  .mr20 {
    margin-bottom: 20px;
  }
</style>
